<template lang="pug">
.container
  .globe(ref="globeElement")
  slot
</template>


<script lang="ts">
import { GlobeComponentType } from './script'
export default GlobeComponentType
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  position: relative;
}

.globe {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>